import{Outlet} from 'react-router-dom'

export default function CategoriesPage() {
  return (
    <div> 
      <Outlet/>
    </div>
  );
}